import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {fetchMatch, fetchMatchActiveApplication, setMatchAllResults, setMatchExtraData,setMatchBestPlayer, unsetMatchBestPlayer,
  changeMatchData, dropMatchState, dropMatch} from '../actions/matches'
import {fetchAllStadiums} from '../actions/stadiumsActions';
import {fetchAllReferees} from '../actions/judjesActions';
import {API_URLS} from '../constants/config'
import defaultTeamLogo from "../images/defaultTeamLogo.png";
import { BASE_URL } from "../constants/config";
import Loader from "react-loader-spinner";
import moment from 'moment'
import useDynamicRefs from 'use-dynamic-refs';
import BottomModal from '../components/BottomModal';
import { FiAlertTriangle } from "react-icons/fi";
import { toServerEventTime, isValidTime, toServerTime } from '../utilities/matchTime';
import _ from "lodash";
import SelectSearch from 'react-select-search';
import Fuse from 'fuse.js';
import CustomModal from "../components/CustomModal";
import PlayerMenu from '../components/PlayerMenu';
import OnlineMatch from './OnlineMatch';
import '../styles/eventsModal.css';
import '../styles/editModal.css';
import '../styles/leagueManagement.css';
import '../styles/matchPage.css';

const EVENT_TYPES = {
  1:  { label: 'Гол', icon: '⚽', hasAssist: true, counted: 'goals' },
  6:  { label: 'Забитый пенальти', icon: '⚽🥅', hasAssist: false, counted: false },
  7:  { label: 'Незабитый пенальти', icon: '❌🥅', hasAssist: false, counted: false },
  8:  { label: 'Автогол', icon: '⚽🔴', hasAssist: false, counted: 'autogoals' },
  16: { label: 'Забитый 10м', icon: '⚽🔟', hasAssist: false, counted: false },
  17: { label: 'Незабитый 10м', icon: '❌🔟', hasAssist: false, counted: false },
  18: { label: 'Забитый 6м', icon: '⚽6️⃣', hasAssist: false, counted: false },
  19: { label: 'Незабитый 6м', icon: '❌6️⃣', hasAssist: false, counted: false },
  3:  { label: 'ЖК', icon: '🟨', hasAssist: false, counted: 'yellow_cards' },
  4:  { label: 'КК', icon: '🟥', hasAssist: false, counted: 'red_cards' },
};

// Сервер хранит главного судью и двух помощников (как cache_ref лиги)
const MAX_REFEREES = 3;

// Особое состояние матча для переключателя в блоке 2
const stateModeOf = (match) => {
  if (!match) return 'none';
  if (Number(match.status) === 5) return 'tech';
  if (match.resheduled) return 'resheduled';
  return 'none';
};

// Метка состояния в шапке — те же правила, что на экране матча в приложении
const matchStatusOf = (match) => {
  if (!match) return null;
  if (match.resheduled) return { label: 'Перенесён', className: 'mpBadgeWarn' };
  const status = match.status === null || match.status === undefined ? null : Number(match.status);
  if (status === 5) return { label: 'Тех. поражение', className: 'mpBadgeDanger' };
  if (status === 2) return { label: 'Завершён', className: 'mpBadgeDone' };
  if (status === 3 || (status === 0 && match.second_time_start)) return { label: 'Перерыв', className: 'mpBadgeLive' };
  if (status === 1 || status === 4) return { label: 'Идёт', className: 'mpBadgeLive' };
  return { label: 'Не начат', className: 'mpBadgeNeutral' };
};

export default function ManageMatchResult(props) {
  const [matchData, setMatchData] = useState(false);
  const [referee, setReferee] = useState('');
  const [matchTime, setMatchTime] = useState('');
  const [stadium, setStadium] = useState('');
  const modalRef = useRef();
  const [matchApplication, setMatchApplication] = useState(false);
  const [stadiumsData, setStadiumsData] = useState([]);
  const [refereesData, setReferees] = useState([]);
  // Особое состояние: 'none' | 'tech' (тех. поражение) | 'resheduled' (перенос)
  const [stateMode, setStateMode] = useState('none');
  const [infoSaving, setInfoSaving] = useState(false);
  const [stateSaving, setStateSaving] = useState(false);
  const [resetModal, setResetModal] = useState(false);
  const [infoModal, setInfoModal] = useState(false);
  // Сохранённые судьи: сервер отдаёт только главного, помощников помним после сохранения
  const [savedReferees, setSavedReferees] = useState([]);
  const [stateModal, setStateModal] = useState(false);
  const [resetting, setResetting] = useState(false);
  const [matchComment,setMatchComment] = useState('');
  const [timelineDis,setTimelineDis] = useState(false);
  const [matchScore, setMatchScore] = useState({home: false, guest: false});
  const [matchTechLoseScore, setMatchTechLoseScore] = useState({home: '0', guest: '0'});
  //const [loading, setLoading] = useState(true);
  const [modalText, setmodalText] = useState('');
  const [modalType, setmodalType] = useState('success');
  const [getRef, setRef] =  useDynamicRefs();

  // Online match modal
  const [onlineMatchVisible, setOnlineMatchVisible] = useState(false);

  const handleOnlineMatchFinish = (results) => {
    // Update score
    setMatchScore({
      home: String(results.score.home),
      guest: String(results.score.guest)
    });

    // Update matchApplication with player stats and active flags
    if (matchApplication) {
      const updated = matchApplication.map(player => {
        const stats = results.playerStats[player.id];
        const isActive = results.activePlayers.includes(player.id);
        return {
          ...player,
          active: isActive,
          goals: stats ? stats.goals : 0,
          assists: stats ? stats.assists : 0,
          autogoals: stats ? stats.autogoals : 0,
          yellow_cards: stats ? stats.yellow_cards : 0,
          red_cards: stats ? stats.red_cards : 0,
        };
      });
      setMatchApplication(updated);
    }

    // Set manual events from online match
    setManualEvents(results.manualEvents);

    // Close modal
    setOnlineMatchVisible(false);
  };

  // Manual events state
  const [manualEvents, setManualEvents] = useState([]);
  const [eventsModalVisible, setEventsModalVisible] = useState(false);
  const [currentEventType, setCurrentEventType] = useState(1);
  const [currentEventPlayer, setCurrentEventPlayer] = useState('');
  const [currentEventAssist, setCurrentEventAssist] = useState('');
  const [currentEventMinute, setCurrentEventMinute] = useState('');
  const [currentEventSecond, setCurrentEventSecond] = useState('');
  const fetchMatchData = useSelector(state => state.matches.matchData.data)
  const fetchMatchApplication = useSelector(state => state.matches.matchActiveApplication.data);
  const loading = useSelector(state => state.matches.loading);
  const loadingFetchApplication = useSelector(state => state.matches.loadingApplication);
  const dispatch = useDispatch();
  const [currentDate, setcurrentDate] = useState(moment(new Date()));


  useEffect(() => {
    if(!matchData){
      loadAsyncMatch()
    }
  }, [matchData]);

  const loadAsyncMatch = () => {//загрузка матча
    let url = API_URLS.getMatch
    url = url + props.match.params.id;
    dispatch(fetchMatch(url)).then(
      match => {
        if (!match || !match.data) return;
        setMatchData(match.data)
        setTimelineDis(!match.data.status ||  (match.data.status && match.data.timeline_disabled) ?false :true)
        setMatchComment(match.data.default_comment && match.data.default_comment.length ?match.data.default_comment :'')
        setMatchScore({home:match.data.home_team_scores === 0 ?'0' :match.data.home_team_scores, guest:match.data.guest_team_scores === 0 ?'0' :match.data.guest_team_scores })
        loadAsyncApplication([match.data.home_team_id, match.data.guest_team_id], props.match.params.id)
        // referees[]: main=1 главный, main=0 помощники — иначе subRefs: false затрёт их
        const fromList = Array.isArray(match.data.referees)
          ? [
              ...match.data.referees.filter(r => Number(r.main) === 1),
              ...match.data.referees.filter(r => Number(r.main) !== 1),
            ].map(r => r.id).filter(Boolean)
          : [];
        const refereeList = fromList.length
          ? fromList.slice(0, MAX_REFEREES)
          : (match.data.judje_id ? [match.data.judje_id] : []);
        setReferee(refereeList)
        setSavedReferees(refereeList)
        setStadium(match.data.stadium_id)
        setcurrentDate(moment(match.data.date))
        setMatchTime(match.data.time ? String(match.data.time).slice(0, 5) : '')
        setStateMode(stateModeOf(match.data))
        if (Number(match.data.status) === 5) {
          setMatchTechLoseScore({
            home: String(match.data.home_team_scores ?? 0),
            guest: String(match.data.guest_team_scores ?? 0),
          })
        }
      }
  );

  }

  const setMatchBestPlayerEvent = (data) => {
    let url = API_URLS.setMatchBestPlayer
    const match_id = props.match.params.id
    dispatch(setMatchBestPlayer(url, data, match_id)).then(
      players => {
        if(players.data){
          const matchApplicationTemp = matchApplication
          matchApplicationTemp.map( item => item.mvp = null)
          players.data.map((item,index) => {
            const id =  matchApplicationTemp.findIndex(appl => appl.id == item.id)
            matchApplicationTemp[id].mvp = true;
          })
          setMatchApplication([...matchApplicationTemp])
        }

      }
  );
  };

  const unsetMatchBestPlayerEvent = (data) => {
    let url = API_URLS.unsetMatchBestPlayer
    const match_id = props.match.params.id
    dispatch(unsetMatchBestPlayer(url, data, match_id)).then(
      players => {
        if(players.data){
          const matchApplicationTemp = matchApplication
          matchApplicationTemp.map( item => item.mvp = null)
          players.data.map((item,index) => {
            const id =  matchApplicationTemp.findIndex(appl => appl.id == item.id)
            matchApplicationTemp[id].mvp = true;
          })
          setMatchApplication([...matchApplicationTemp])
        }
      }
    );
  };

  const setMatchExtraDataAsync = (resheduled,tech_lose) => {
    
    let url = API_URLS.setMatchExtraData
    let tech_defeat = false;
    let resheduled_temp = false
    
    if(resheduled){
      resheduled_temp = true;
    } else if(tech_lose && (matchTechLoseScore.home !== '0' || matchTechLoseScore.guest !== '0')){
      tech_defeat = true;
    }
    return dispatch(setMatchExtraData(url, matchData.id, {
      comment: matchComment && matchComment.length ?matchComment :false,
      resheduled: resheduled_temp,
      tech_defeat,
      timeline_disabled:timelineDis,
      tech_defeat_home:matchTechLoseScore.home,
      tech_defeat_guest:matchTechLoseScore.guest})).then(
      match => {
        if (!match || !match.data) {
          setmodalType('error')
          setmodalText('Не удалось сохранить: сервер вернул ошибку. Изменения не записаны.')
          toggleModal();
          return false;
        }
        setMatchData(match.data)
        setTimelineDis(!match.data.status ||  (match.data.status && match.data.timeline_disabled) ?false :true)
        setMatchComment(match.data.default_comment && match.data.default_comment.length ?match.data.default_comment :'')
        setMatchScore({home:match.data.home_team_scores === 0 ?'0' :match.data.home_team_scores, guest:match.data.guest_team_scores === 0 ?'0' :match.data.guest_team_scores })
        setStateMode(stateModeOf(match.data))
        setmodalType('success')
        setmodalText('Особое состояние и комментарий сохранены.')
        toggleModal();
        return true;
      }
  );

  }

  const setResultsAsync = (application, events, newMatchData) => {
    
    let url = API_URLS.setAllResults
    /*props.actions.setMatchAllResults(url, matchData.id, application, events, score).then(
        match => {
          setmodalType('success')
          setmodalText('Результаты матча успешно изменены.')
          toggleModal();
        }
    );*/
    dispatch(setMatchAllResults(url, matchData.id, application, events, newMatchData)).then(
      match => {
        if (!match || !match.data) {
          setmodalType('error')
          setmodalText('Не удалось сохранить: сервер вернул ошибку. Изменения не записаны.')
          toggleModal();
          return;
        }
        setMatchData(match.data)
        setTimelineDis(!match.data.status ||  (match.data.status && match.data.timeline_disabled) ?false :true)
        setMatchComment(match.data.default_comment && match.data.default_comment.length ?match.data.default_comment :'')
        setMatchScore({home:match.data.home_team_scores === 0 ?'0' :match.data.home_team_scores, guest:match.data.guest_team_scores === 0 ?'0' :match.data.guest_team_scores })
        setmodalType('success')
        setmodalText('Результаты матча успешно изменены.')
        toggleModal();
      }
  );

  }

  const getRandomInt = (half_time) => {
    const min = 11;
    const max = (parseInt(half_time, 10) > 0 ? parseInt(half_time, 10) : 30) * 2;
    return Math.floor(Math.random() * (max - min)) + min; //Максимум не включается, минимум включается
  }


  const loadAsyncApplication = (team_id, match_id) => { // загрузка заявки
    let url = API_URLS.getMatchActiveApplication;
    dispatch(fetchMatchActiveApplication(url, team_id, match_id)).then(
      application => {
        console.log('application',application)
        setMatchApplication(application.data)  
        loadAsyncStadiums();
      }
  );
  };

  const loadAsyncStadiums = () => { // загрузка стадионов
    let url = API_URLS.getAllStadiums;
    dispatch(fetchAllStadiums(url)).then(
      stadiums => {
        const temp_stadiums = []
        stadiums.data.map((item, index) => {
          item.value = item.id;
          item.key = index
          temp_stadiums.push(item)
        })
        setStadiumsData(temp_stadiums)  
        loadAsyncReferees();
      }
  );
  };

  const loadAsyncReferees = () => { // загрузка судей
    let url = API_URLS.getAllReferees;
    dispatch(fetchAllReferees(url)).then(
      referees => {
        const temp_referees = []
        referees.data.map((item, index) => {
          item.value = item.id;
          item.key = index;
          item.name = item.family + ' ' + item.name
          temp_referees.push(item)
        })

        setReferees(temp_referees)  
      }
  );
  };

  const getErrorMessage = (players) => {
    if(players.length == 1){
      setmodalText('Игрок ' + players[0].family + ' ' + players[0].name + ' ( ' + players[0].team_name + ') совершил события, но не завялен на матч.')
    } else {
      setmodalText('Игроки ' + players[0].family + ' ' + players[0].name + ' ( ' + players[0].team_name + ') и еще ' + (players.length - 1).toString() + ' совершили события, но не завялены на матч.')
    }
    setmodalType('error')
  }

  // ============ ДАННЫЕ МАТЧА / СОСТОЯНИЕ / СБРОС ============

  const showToast = (type, text) => {
    setmodalType(type)
    setmodalText(text)
    toggleModal();
  }

  const serverMessage = (error, fallback) => {
    const data = error && error.response && error.response.data;
    if (typeof data === 'string' && data) return data;
    if (data && (data.message || data.error)) return data.message || data.error;
    return fallback;
  }

  const refereeIds = () => (Array.isArray(referee) ? referee : [referee])
    .filter(id => id !== '' && id !== null && id !== undefined && id !== false);

  // Блок «Данные матча»: только дата, время, стадион и судьи через changeMatch.
  // Матч дочитываем целиком — changeMatch ждёт полный match_data, а счёт,
  // состояние, заявку и события эта кнопка трогать не должна
  const saveMatchInfo = async () => {
    if (!currentDate || !currentDate.isValid()) {
      showToast('error', 'Укажите дату матча.');
      return;
    }
    if (!isValidTime(matchTime)) {
      showToast('error', 'Время начала — в формате ЧЧ:ММ.');
      return;
    }
    setInfoSaving(true);
    try {
      const full = await dispatch(fetchMatch(API_URLS.getMatch + matchData.id));
      if (!full || !full.data || !full.data.id) {
        throw new Error('Не удалось дочитать матч перед сохранением');
      }
      const refs = refereeIds().slice(0, MAX_REFEREES);
      const next = {
        ...full.data,
        date: currentDate.format('YYYY-MM-DD'),
        time: toServerTime(matchTime),
        stadium_id: stadium === '' || stadium === null || stadium === undefined ? null : Number(stadium),
        judje_id: refs.length ? Number(refs[0]) : null,
        // Как в приложении: первый судья — главный, остальные уходят в subRefs
        subRefs: refs.length > 1 ? refs.slice(1).map(id => ({ id: Number(id) })) : false,
      };
      await dispatch(changeMatchData(Number(matchData.id), next));
      setMatchData(prev => ({
        ...prev,
        date: next.date,
        time: next.time,
        stadium_id: next.stadium_id,
        judje_id: next.judje_id,
      }));
      setSavedReferees(refs);
      setInfoModal(false);
      showToast('success', 'Данные матча сохранены. Счёт и состояние не менялись.');
    } catch (error) {
      console.error('Не удалось сохранить данные матча', error);
      showToast('error', serverMessage(error, 'Не удалось сохранить данные матча.'));
    } finally {
      setInfoSaving(false);
    }
  }

  // Модалки открываются с данными матча: несохранённые правки прошлого открытия не тянем
  const openInfoModal = () => {
    setcurrentDate(moment(matchData.date));
    setMatchTime(matchData.time ? String(matchData.time).slice(0, 5) : '');
    setStadium(matchData.stadium_id || '');
    setReferee(savedReferees);
    setInfoModal(true);
  }

  const openStateModal = () => {
    setStateMode(stateModeOf(matchData));
    setMatchComment(matchData.default_comment && matchData.default_comment.length ? matchData.default_comment : '');
    setStateModal(true);
  }

  const techScoreValid = () => (
    (matchTechLoseScore.home !== '0' && matchTechLoseScore.home.length > 0)
    || (matchTechLoseScore.guest !== '0' && matchTechLoseScore.guest.length > 0)
  );

  const saveState = async () => {
    if (stateMode === 'tech' && !techScoreValid()) {
      showToast('error', 'Укажите счёт технического поражения, например 3 : 0.');
      return;
    }
    setStateSaving(true);
    try {
      const saved = await setMatchExtraDataAsync(stateMode === 'resheduled', stateMode === 'tech');
      if (saved) setStateModal(false);
    } finally {
      setStateSaving(false);
    }
  }

  const resetMatch = async (kind) => {
    const question = kind === 'state'
      ? 'Сбросить состояние матча? Заявка, события и счёт останутся.'
      : 'Сбросить матч полностью? Удалятся заявка игроков на матч, события и счёт.';
    if (!window.confirm(question)) return;
    setResetting(true);
    try {
      await dispatch(kind === 'state' ? dropMatchState(Number(matchData.id)) : dropMatch(Number(matchData.id)));
      setResetModal(false);
      if (kind === 'full') setManualEvents([]);
      // Перечитываем матч и заявку заново
      setMatchData(false);
      showToast('success', kind === 'state' ? 'Состояние матча сброшено.' : 'Матч сброшен полностью.');
    } catch (error) {
      console.error('Не удалось сбросить матч', error);
      showToast('error', serverMessage(error, 'Не удалось сбросить матч.'));
    } finally {
      setResetting(false);
    }
  }

  // «Внести результат» завершает матч: пустой протокол превращался в 0:0
  const finishMatch = () => {
    if (!isValidTime(matchTime)) {
      showToast('error', 'Время начала в блоке «Данные матча» — в формате ЧЧ:ММ.');
      return;
    }
    const present = Array.isArray(matchApplication) ? matchApplication.filter(player => player.active).length : 0;
    const noScore = !matchScore.home && !matchScore.guest;
    if (present === 0 && noScore) {
      if (!window.confirm('Ни один игрок не отмечен на матче, и счёт не указан. Матч станет завершённым со счётом 0 : 0. Продолжить?')) return;
    } else if (present === 0) {
      if (!window.confirm('Ни один игрок не отмечен на матче — матч сохранится без составов. Продолжить?')) return;
    } else if (noScore) {
      if (!window.confirm('Счёт не указан — матч станет завершённым со счётом 0 : 0. Продолжить?')) return;
    }
    changeResults();
  }

  // ============ EVENTS MODAL LOGIC ============

  const isCountedEvent = (eventType) => {
    const type = EVENT_TYPES[parseInt(eventType)];
    return type && type.counted;
  };

  const getPlayersForEventType = (eventType) => {
    if (!matchApplication) return [];
    if (!isCountedEvent(eventType)) {
      // Free event — any active player can be selected
      return matchApplication.filter(p => p.active);
    }
    return matchApplication.filter(p => {
      const count = getPlayerStatCount(p, eventType);
      const assigned = getAssignedCount(p.id, eventType);
      return count > assigned;
    });
  };

  const getPlayerStatCount = (player, eventType) => {
    const type = EVENT_TYPES[parseInt(eventType)];
    if (!type || !type.counted) return 0;
    return parseInt(player[type.counted]) || 0;
  };

  const getAssignedCount = (playerId, eventType) => {
    return manualEvents.filter(e => e.player_id === playerId && e.event_type === parseInt(eventType)).length;
  };

  const getAssistPlayersForGoal = (goalPlayerId) => {
    if (!matchApplication) return [];
    const goalPlayer = matchApplication.find(p => p.id === goalPlayerId);
    if (!goalPlayer) return [];
    return matchApplication.filter(p => {
      if (p.id === goalPlayerId) return false;
      if (p.team_id !== goalPlayer.team_id) return false;
      const totalAssists = parseInt(p.assists) || 0;
      const assignedAssists = manualEvents.filter(e => e.assist_player_id === p.id).length;
      return totalAssists > assignedAssists;
    });
  };

  const resetEventForm = () => {
    setCurrentEventPlayer('');
    setCurrentEventAssist('');
    setCurrentEventMinute('');
    setCurrentEventSecond('');
  };

  const addManualEvent = () => {
    if (!currentEventPlayer || currentEventMinute === '') return;
    const player = matchApplication.find(p => p.id === parseInt(currentEventPlayer));
    if (!player) return;

    const sec = currentEventSecond === '' ? '00' : currentEventSecond.padStart(2, '0');

    const newEvent = {
      id: Date.now(),
      event_type: parseInt(currentEventType),
      player_id: player.id,
      player_name: player.family + ' ' + player.name,
      player_number: player.player_number,
      team_id: player.team_id,
      team_name: matchData.home_team_id === player.team_id ? matchData.home_team_name : matchData.guest_team_name,
      minute: parseInt(currentEventMinute),
      second: parseInt(sec),
      time: toServerEventTime(parseInt(currentEventMinute, 10), parseInt(sec, 10)),
      time_number: parseInt(currentEventMinute) > parseInt(matchData.half_time) ? 2 : 1,
      assist_player_id: null,
      assist_player_name: null,
    };

    const evtType = EVENT_TYPES[parseInt(currentEventType)];
    if (evtType && evtType.hasAssist && currentEventAssist) {
      const assistPlayer = matchApplication.find(p => p.id === parseInt(currentEventAssist));
      if (assistPlayer) {
        newEvent.assist_player_id = assistPlayer.id;
        newEvent.assist_player_name = assistPlayer.family + ' ' + assistPlayer.name;
      }
    }

    setManualEvents([...manualEvents, newEvent]);
    resetEventForm();
  };

  const removeManualEvent = (eventId) => {
    setManualEvents(manualEvents.filter(e => e.id !== eventId));
  };

  const getTotalAssignedForType = (eventType) => {
    return manualEvents.filter(e => e.event_type === parseInt(eventType)).length;
  };

  const getTotalNeededForType = (eventType) => {
    if (!matchApplication) return 0;
    let total = 0;
    matchApplication.forEach(p => {
      total += getPlayerStatCount(p, eventType);
    });
    return total;
  };

  const allEventsAssigned = () => {
    // Only check counted event types (goals, autogoals, YC, RC)
    const countedTypes = Object.entries(EVENT_TYPES).filter(([, t]) => t.counted).map(([id]) => parseInt(id));
    return countedTypes.every(type => getTotalAssignedForType(type) >= getTotalNeededForType(type));
  };

  // Add manual events to events array and subtract their counts from tempApplication
  const addManualEventsToArray = (events, tempApp) => {
    if (manualEvents.length === 0) return;
    const sorted = [...manualEvents].sort((a, b) => a.minute - b.minute || a.second - b.second);

    sorted.forEach(me => {
      let eventId = me.event_type;
      if (me.event_type === 3) {
        const prevYC = sorted.filter(e => e.event_type === 3 && e.player_id === me.player_id && (e.minute < me.minute || (e.minute === me.minute && e.second < me.second) || (e.minute === me.minute && e.second === me.second && e.id < me.id)));
        if (prevYC.length > 0 && prevYC.length % 2 !== 0) {
          eventId = 13;
        }
      }

      events.push({
        match_id: matchData.id, event_id: eventId,
        player_id: me.player_id, team_id: me.team_id,
        league_id: matchData.league_id, time: me.time, time_number: me.time_number
      });

      // Subtract counted event from remaining
      const type = EVENT_TYPES[me.event_type];
      if (type && type.counted) {
        const pidx = tempApp.findIndex(p => p.id === me.player_id);
        if (pidx !== -1) tempApp[pidx][type.counted] = Math.max(0, (parseInt(tempApp[pidx][type.counted]) || 0) - 1);
      }

      // Add assist event right after goal and subtract assist count
      if (me.event_type === 1 && me.assist_player_id) {
        const assistPlayer = matchApplication.find(p => p.id === me.assist_player_id);
        events.push({
          match_id: matchData.id, event_id: 2,
          player_id: me.assist_player_id,
          team_id: assistPlayer ? assistPlayer.team_id : me.team_id,
          league_id: matchData.league_id, time: me.time, time_number: me.time_number
        });
        const aidx = tempApp.findIndex(p => p.id === me.assist_player_id);
        if (aidx !== -1) tempApp[aidx].assists = Math.max(0, (parseInt(tempApp[aidx].assists) || 0) - 1);
      }
    });
  };

  const changeResults = () => {
    const errorPlayers = [];
    const teams = {}
    const newApplication = []
    
    // Hybrid events: manual events keep their times, remaining get random times
    const events = [];
    
    // System events
    events.push({
      match_id: matchData.id, event_id: 9, player_id: null, team_id: null,
      league_id: matchData.league_id, time: '00:00:00', time_number: 1
    });
    events.push({
      match_id: matchData.id, event_id: 10, player_id: null, team_id: null,
      league_id: matchData.league_id, time: toServerEventTime(parseInt(matchData.half_time, 10) || 30, 0), time_number: 2
    });
    events.push({
      match_id: matchData.id, event_id: 11, player_id: null, team_id: null,
      league_id: matchData.league_id, time: toServerEventTime((parseInt(matchData.half_time, 10) || 30) * 2, 0), time_number: 2
    });

    let tempApplication = _.cloneDeep(matchApplication);
    let matchDataTemp = _.cloneDeep(matchScore);
    teams[matchData.home_team_id] = matchData.home_team_name;
    teams[matchData.guest_team_id] = matchData.guest_team_name;

    // Add manual events and subtract their counts from tempApplication
    addManualEventsToArray(events, tempApplication);

    // First pass: pair remaining goals with assists (random times)
    matchApplication.map((player) => {
      {
        let index = -1;
        let max_value = 0;
        tempApplication.map((temp_player, id) => {
          if(temp_player.goals + temp_player.assists > max_value){
            max_value = temp_player.goals + temp_player.assists
            index = id
          }
        })
        const minutes = getRandomInt(matchData.half_time);
        const time = toServerEventTime(minutes, Math.floor(Math.random() * 60))
        if(index !== -1 ){
          if(tempApplication[index] && tempApplication[index].goals && tempApplication[index].goals > 0){
            let assist_index = tempApplication.findIndex(player => tempApplication[index].id != player.id && player.team_id == tempApplication[index].team_id && player.assists && player.assists > 0)
            events.push({
              match_id: matchData.id,
              event_id: 1,
              player_id: tempApplication[index].id,
              team_id: tempApplication[index].team_id,
              league_id : matchData.league_id,
              time,
              time_number: minutes > (parseInt(matchData.half_time)) ?2 :1 
            })
            if(assist_index !== -1){
              events.push({
                match_id: matchData.id,
                event_id: 2,
                player_id: tempApplication[assist_index].id,
                team_id: tempApplication[assist_index].team_id,
                league_id : matchData.league_id,
                time,
                time_number: minutes > (parseInt(matchData.half_time)) ?2 :1 
              })
              tempApplication[assist_index].assists = tempApplication[assist_index].assists - 1
            }
          }
          tempApplication[index].goals = tempApplication[index].goals - 1
        }
      }
      if(!player.active && (parseInt(player.goals) || parseInt(player.autogoals) || parseInt(player.assists) || parseInt(player.yellow_cards) || parseInt(player.red_cards))){
        errorPlayers.push({...player, team_name: teams[player.team_id]})
      }
      if(player.active){
        newApplication.push({match_id:matchData.id, team_id: player.team_id, player_id: player.id, from_double: player.isDouble && player.isDouble != null ?1 :null, position_id: player.match_position })
      }
    })
    if(errorPlayers.length > 0){
      getErrorMessage(errorPlayers)
      toggleModal();
      return null;
    } else {
      // Second pass: remaining events with random times
      tempApplication.map((player) => {
        if(player.goals && player.goals > 0){
          for(let i=0; player.goals > i;i++){
            const minutes = getRandomInt(matchData.half_time);
            const time = toServerEventTime(minutes, Math.floor(Math.random() * 60))
            events.push({
              match_id: matchData.id,
              event_id: 1,
              player_id: player.id,
              team_id: player.team_id,
              league_id : matchData.league_id,
              time,
              time_number: minutes > (parseInt(matchData.half_time)) ?2 :1 
            })
          }
        }
        if(player.autogoals && player.autogoals > 0){
          for(let i=0; player.autogoals > i;i++){
            const minutes = getRandomInt(matchData.half_time);
            const time = toServerEventTime(minutes, Math.floor(Math.random() * 60))
            events.push({
              match_id: matchData.id,
              event_id: 8,
              player_id: player.id,
              team_id: player.team_id,
              league_id : matchData.league_id,
              time,
              time_number: minutes > (parseInt(matchData.half_time)) ?2 :1 
            })
          }
        }
        if(player.assists && player.assists > 0){
          for(let i=0; player.assists > i;i++){
            const minutes = getRandomInt(matchData.half_time);
            const time = toServerEventTime(minutes, Math.floor(Math.random() * 60))
            events.push({
              match_id: matchData.id,
              event_id: 2,
              player_id: player.id,
              team_id: player.team_id,
              league_id : matchData.league_id,
              time,
              time_number: minutes > (parseInt(matchData.half_time)) ?2 :1 
            })
          }
        }
        if(player.yellow_cards && player.yellow_cards > 0){
          const manualYCCount = manualEvents.filter(e => e.event_type === 3 && e.player_id === player.id).length;
          for(let i=0; player.yellow_cards > i;i++){
            const totalIdx = manualYCCount + i;
            if(totalIdx % 2 != 0){
              const minutes = getRandomInt(matchData.half_time);
              const time = toServerEventTime(minutes, Math.floor(Math.random() * 60))
              events.push({
                match_id: matchData.id,
                event_id: 13,
                player_id: player.id,
                team_id: player.team_id,
                league_id : matchData.league_id,
                time,
                time_number: minutes > (parseInt(matchData.half_time)) ?2 :1 
              })
            } else {
              const minutes = getRandomInt(matchData.half_time);
              const time = toServerEventTime(minutes, Math.floor(Math.random() * 60))
              events.push({
                match_id: matchData.id,
                event_id: 3,
                player_id: player.id,
                team_id: player.team_id,
                league_id : matchData.league_id,
                time,
                time_number: minutes > (parseInt(matchData.half_time)) ?2 :1 
              })
            }
          }
        }
        if(player.red_cards && player.red_cards > 0){
          for(let i=0; player.red_cards > i;i++){
            const minutes = getRandomInt(matchData.half_time);
            const time = toServerEventTime(minutes, Math.floor(Math.random() * 60))
            events.push({
              match_id: matchData.id,
              event_id: 4,
              player_id: player.id,
              team_id: player.team_id,
              league_id : matchData.league_id,
              time,
              time_number: minutes > (parseInt(matchData.half_time)) ?2 :1 
            })
          }
        }
      })
      matchDataTemp.stadium_id = null;
      matchDataTemp.judje_id = null;
      matchDataTemp.time = null;
      if(!matchDataTemp.guest || (matchDataTemp.guest && matchDataTemp.guest === '')) matchDataTemp.guest = 0
      if(!matchDataTemp.home || (matchDataTemp.home && matchDataTemp.home === '')) matchDataTemp.home = 0
      if(stadium || stadium != '') matchDataTemp.stadium_id = stadium
      if(referee && referee.length) {
        matchDataTemp.judje_id = referee[0]
        const subRefs = _.cloneDeep(referee);
        subRefs.shift();
        matchDataTemp.subRefs = subRefs;
      } else {
        matchDataTemp.judje_id = Array.isArray(referee) || referee === '' ? null : referee;
      }
      matchDataTemp.date = currentDate.format("YYYY-MM-DD")
      matchDataTemp.time = toServerTime(matchTime);
      matchDataTemp.timeline_disabled = timelineDis;
      setResultsAsync(newApplication, events, matchDataTemp)
      return null;
    }
  }


  const rendeTeamImage = (image) => {
    if(!image || (image && image == '') || (image && image == '/images/others/defaultLogo.png')){
      return (
        <img src={defaultTeamLogo} className="teamImage"/>  
      )
    } else {
      return (
        <img src={BASE_URL.url + image} className="teamImage"/>  
      )
    }
  }

  const changeActivity = (player_index) => {
    const matchApplicationTemp = matchApplication
    matchApplicationTemp[player_index].active = !matchApplicationTemp[player_index].active
    setMatchApplication([...matchApplicationTemp])
  }

  const chooseAll = (team_id) => {
      const matchApplicationTemp = matchApplication
      let method = true;
      matchApplicationTemp.map(item => {
        if(item.team_id == team_id && item.active){
          method = false
        }
      })
      matchApplicationTemp.map(item => {
        if(item.team_id == team_id){
          if(method){
            item.active = true;
          } else {
            item.active = false;
          }
        }
      })
      setMatchApplication([...matchApplicationTemp])
  }

  const changeEvents = (event, player_index, event_type) => {
    const matchApplicationTemp = matchApplication
    matchApplicationTemp[player_index][event_type] = event.target.value.replace(/[^0-9\.]/g, '');
    if(parseInt(event.target.value.replace(/[^0-9\.]/g, '')) && parseInt(event.target.value.replace(/[^0-9\.]/g, ''))>0){
      matchApplicationTemp[player_index].active = 1;
    }
    setMatchApplication([...matchApplicationTemp])
    // Auto-calculate score when goals or autogoals change
    if (event_type === 'goals' || event_type === 'autogoals') {
      recalculateScore(matchApplicationTemp);
    }
  }

  const recalculateScore = (application) => {
    if (!matchData) return;
    let homeScore = 0;
    let guestScore = 0;
    application.forEach(player => {
      const goals = parseInt(player.goals) || 0;
      const autogoals = parseInt(player.autogoals) || 0;
      if (player.team_id === matchData.home_team_id) {
        homeScore += goals;
        guestScore += autogoals;
      } else if (player.team_id === matchData.guest_team_id) {
        guestScore += goals;
        homeScore += autogoals;
      }
    });
    setMatchScore({ home: homeScore.toString(), guest: guestScore.toString() });
  }

  const focusInput = (ref_name) => {
    const qwer = getRef(ref_name);
    if(qwer && qwer.current){
      qwer.current.focus();
    }
  }

  const changeKeeperState = (pl) => {
    if(pl.match_position == 4){
      const matchApplicationTemp = matchApplication
      const index = matchApplicationTemp.findIndex(player => player.id == pl.id)
      matchApplicationTemp[index].match_position = null;
      setMatchApplication([...matchApplicationTemp])
    } else {
      const matchApplicationTemp = matchApplication
      matchApplicationTemp.map( item => {
        if(item.team_id == pl.team_id)
        item.match_position = null 
      })
      const index = matchApplicationTemp.findIndex(player => player.id == pl.id)
      matchApplicationTemp[index].match_position = 4;
      setMatchApplication([...matchApplicationTemp])
    }
  }

  const changeMvpState = (pl) => {
    if(pl.mvp == null){
      const match_id = props.match.params.id
      const data = {
        match_id,
        player_id:pl.id,
        team_id:pl.team_id,
      }
      setMatchBestPlayerEvent(data)
    } else {
      const match_id = props.match.params.id
      const data = {
        match_id,
        player_id:pl.id,
        team_id:pl.team_id,
      }
      unsetMatchBestPlayerEvent(data)
    }
  }

  const getAllAmount = (type, team_id, type2) => {
    let count = 0;
    if(type){
      if(matchApplication){
        matchApplication.map(player => {
          if(player.team_id == team_id && player[type] && player[type] !== 0){
            count = count + parseInt(player[type])
          }
          if(type2 && player.team_id != team_id && player[type2] && player[type2] !== 0){
            count = count + parseInt(player[type2])
          }
        })
        return count;
      } else {
        return 0;
      }
    } else {
      if(matchApplication){
        return matchApplication.filter(player => player.team_id == team_id).length
      } else {
        return 0;
      }
    }
  }

  const isPlayerDisqualified = (player) => {
    if (!player) {
      return false;
    }

    if (Number(player.is_disqualified) === 1) {
      return true;
    }

    if (player.disqualification_data?.auto?.active) {
      return true;
    }

    if (player.disqualification_data?.manual?.active) {
      return true;
    }

    return false;
  };

  const getPlayerDisqualificationReason = (player) => {
    if (!player) {
      return '';
    }

    const reasons = [];

    if (player.disqualification_reason) {
      reasons.push(player.disqualification_reason);
    }

    if (player.disqualification_data?.auto?.active && player.disqualification_data?.auto?.reason) {
      reasons.push(player.disqualification_data.auto.reason);
    }

    if (player.disqualification_data?.manual?.active) {
      const manualItems = Array.isArray(player.disqualification_data?.manual?.items)
        ? player.disqualification_data.manual.items
        : [];

      manualItems.forEach((item) => {
        if (item?.reason) {
          reasons.push(item.reason);
        } else if (item?.to_date) {
          reasons.push(`Ручная дисквалификация до ${moment(item.to_date).format('DD.MM.YYYY')}`);
        } else if (item?.matches_amount) {
          reasons.push(`Ручная дисквалификация на ${item.matches_amount} матч(а/ей)`);
        }
      });
    }

    return _.uniq(reasons).filter((item) => !!item).join(' | ');
  };

  const toggleModal = () => {
    if(modalRef && modalRef.current && modalRef.current.classList){
      if(modalRef.current.classList.contains('matchResultsModalWrapperActive')) {
        modalRef.current.classList.remove('matchResultsModalWrapperActive')
      }
        modalRef.current.classList.add('matchResultsModalWrapperActive')
        setTimeout(()=> {
          if(modalRef && modalRef.current && modalRef.current.classList)
            modalRef.current.classList.remove('matchResultsModalWrapperActive')
        },5000)
    }
  }

  const renderWarning = () => {
    const warnings = [];

    if (matchData && matchData.home_team_id && matchScore.home !== null && matchScore.home !== ''
      && getAllAmount('goals', matchData.home_team_id, 'autogoals') !== parseInt(matchScore.home)) {
      warnings.push(`Количество голов команды ${matchData.home_team_name} (${getAllAmount('goals', matchData.home_team_id, 'autogoals')}) не совпадает с счетом (${matchScore.home})`);
    }

    if (matchData && matchData.guest_team_id && matchScore.guest !== null && matchScore.guest !== ''
      && getAllAmount('goals', matchData.guest_team_id, 'autogoals') !== parseInt(matchScore.guest)) {
      warnings.push(`Количество голов команды ${matchData.guest_team_name} (${getAllAmount('goals', matchData.guest_team_id, 'autogoals')}) не совпадает с счетом (${matchScore.guest})`);
    }

    const disqualifiedActivePlayers = Array.isArray(matchApplication)
      ? matchApplication.filter((player) => player.active && isPlayerDisqualified(player))
      : [];

    if (disqualifiedActivePlayers.length > 0) {
      const warningText = disqualifiedActivePlayers.map((player) => {
        const reason = getPlayerDisqualificationReason(player);
        const name = `${player.family || ''} ${player.name || ''}`.trim();
        return reason ? `${name}: ${reason}` : `${name}: игрок дисквалифицирован`;
      }).join('; ');

      warnings.push(`В активной заявке есть дисквалифицированные игроки: ${warningText}`);
    }

    if (warnings.length === 0) {
      return (
        <div className="emptyWarningBox"/>
      );
    }

    return (
      <div>
        {warnings.map((warning, index) => (
          <div className="matchResultsWarningWrapper" key={index}>
            <div className="matchResultsWarningContent">
              <div className="matchResultsWarningRow">
                <FiAlertTriangle size="1.5em" color="#8A6D3B"/>
                <span className="bottomModalHeading">Предупреждение</span>
              </div>
              <div className="matchResultsWarningRow">
                <span className="bottomModalText">{warning}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  const renderSubs = (team_id) => {
    if(matchApplication && matchApplication.length>0){
      return matchApplication.map((player, index) => {
        if(player.team_id == team_id || player.isDouble == team_id){
          const disqualified = isPlayerDisqualified(player);
          return (
            <tr className="matchCenterRow" key={team_id + '_' + index}>
              <td className="matchSubsColumn">{player.player_number}</td>
          <td className="matchSubsPlayer">
            <PlayerMenu
              text={player.family + ' ' + player.name + ' ' + (player.isDouble == team_id ?'(Д)' :'') + ' ' + (player.mvp != null ?'(MVP)' :'') + ' ' + (player.match_position == 4 ?'(ВРТ)' :'') + ' ' + (disqualified ? '(ДИСКВ)' : '')}
              changeMvpState={()=>changeMvpState(player)}
              changeKeeperState={()=>changeKeeperState(player)}
            /></td>
              <td className="matchSubsColumn" onClick={()=>changeActivity(index)}>
                <input
                  name="Присутсвие"
                  type="checkbox"
                  checked={player.active}
                  onChange={()=>{}}/>
              </td>
              <td className="matchSubsColumn" onClick={()=>focusInput(index + '_goals')}>
                <input className="matchColumnInput" ref={setRef(index + '_goals')} placeholder="" onChange={(event)=>changeEvents(event, index, 'goals')} type="text" name="Голы" value={player.goals !== false && player.goals !== null ?player.goals :''}/>
              </td>
              <td className="matchSubsColumn" onClick={()=>focusInput(index + '_assists')}>
                <input className="matchColumnInput" ref={setRef(index + '_assists')} placeholder="" onChange={(event)=>changeEvents(event, index, 'assists')} type="text" name="Голевые передачи" value={player.assists !== false && player.assists !== null ?player.assists :''}/>
              </td>
              <td className="matchSubsColumn" onClick={()=>focusInput(index + '_autogoals')}>
                <input className="matchColumnInput" ref={setRef(index + '_autogoals')} placeholder="" onChange={(event)=>changeEvents(event, index, 'autogoals')} type="text" name="Автоголы" value={player.autogoals !== false && player.autogoals !== null ?player.autogoals :''}/>
              </td>
              <td className="matchSubsColumn" onClick={()=>focusInput(index + '_yellow_cards')}>
                <input className="matchColumnInput" ref={setRef(index + '_yellow_cards')} placeholder="" onChange={(event)=>changeEvents(event, index, 'yellow_cards')} type="text" name="Желтые карточки" value={player.yellow_cards !== false && player.yellow_cards !== null ?player.yellow_cards :''}/>
              </td>
              <td className="matchSubsColumn" onClick={()=>focusInput(index + '_red_cards')}>
                <input className="matchColumnInput" ref={setRef(index + '_red_cards')} placeholder="" onChange={(event)=>changeEvents(event, index, 'red_cards')} type="text" name="Красные карточки" value={player.red_cards !== false && player.red_cards !== null ?player.red_cards :''}/> 
              </td>
            </tr>
          )
        }
      })
    } else {
      return (
        <tr>
          <td colSpan="8" className="emptyRow">
          <span className="emptyRowText">Состав команды не заявлен</span>
          </td>
        </tr>

      )
    }
  }

  const changeScore = (event, input_type) => {
    setMatchScore((prevState => ({
      ...prevState,
      [input_type]: event.target.value.replace(/[^0-9\.]/g, ''),
    })
    ))
  }

  const changeScoreLoseScore = (event, input_type) => {
    setMatchTechLoseScore((prevState => ({
      ...prevState,
      [input_type]: event.target.value.replace(/[^0-9\.]/g, ''),
    })
    ))
  }

  const fuzzySearch = (options) => {
    const fuse = new Fuse(options, {
      keys: ['name'],
      threshold: 0.3,
  });

  return (value) => {
      if (!value.length) {
          return options;
      }
      return fuse.search(value).map(item => item.item);

  };
  }

  const STATE_MODES = [
    { value: 'none', title: 'Обычный матч', hint: 'без особого состояния' },
    { value: 'tech', title: 'Тех. поражение', hint: 'счёт ставится вручную' },
    { value: 'resheduled', title: 'Перенесён', hint: 'матч сыграют позже' },
  ];

  const MODAL_CONTENT = { overflow: 'visible' };

  // Судьи матча: первый — главный (judje_id), остальные уходят в subRefs
  const refereeName = (id) => {
    const item = refereesData.find(ref => String(ref.value) === String(id));
    return item ? item.name : `Судья #${id}`;
  }

  const refereeOptionsToAdd = () => {
    const chosen = refereeIds().map(String);
    return refereesData.filter(ref => !chosen.includes(String(ref.value)));
  }

  const addReferee = (id) => {
    if (id === '' || id === null || id === undefined) return;
    const current = refereeIds();
    if (current.length >= MAX_REFEREES) return;
    if (current.some(item => String(item) === String(id))) return;
    setReferee([...current, id]);
  }

  const removeReferee = (index) => {
    setReferee(refereeIds().filter((item, i) => i !== index));
  }

  const makeMainReferee = (index) => {
    const current = refereeIds();
    setReferee([current[index], ...current.filter((item, i) => i !== index)]);
  }

  const renderRefereeList = () => {
    const ids = refereeIds();
    if (ids.length === 0) {
      return <span className="fieldHint mpSummaryMissing" style={{ marginTop: 0 }}>Судья не назначен</span>;
    }
    return (
      <div className="mpRefList">
        {ids.map((id, index) => (
          <div className="mpRefRow" key={String(id)}>
            <span className={`mpRefRole ${index === 0 ? 'mpRefRoleMain' : ''}`}>
              {index === 0 ? 'Главный' : 'Помощник'}
            </span>
            <span className="mpRefName">{refereeName(id)}</span>
            {index > 0 && (
              <button type="button" className="linkButton" onClick={() => makeMainReferee(index)}>
                Сделать главным
              </button>
            )}
            <button type="button" className="mpRefRemove" aria-label="Убрать судью" title="Убрать" onClick={() => removeReferee(index)}>
              ×
            </button>
          </div>
        ))}
      </div>
    );
  }

  const renderMatchInfoModal = () => (
    <CustomModal
      styles={{width:640, height:'auto', paddingLeft:36, paddingRight:36}}
      contentStyle={MODAL_CONTENT}
      visible={infoModal}
      closeModal={() => { if (!infoSaving) setInfoModal(false); }}>
      <div className="mpModalBody">
        <div className="customModalHeaderTwo">Данные матча</div>
        <p className="fieldHint" style={{ marginTop: 0 }}>
          Дата, время, стадион и судьи. Счёт, составы и состояние матча не меняются.
        </p>
        <div className="mpGrid">
          <div className="mpField">
            <label className="modalLabel" htmlFor="mpDate">Дата</label>
            <input
              id="mpDate"
              type="date"
              className="modalInput"
              value={currentDate && currentDate.isValid() ? currentDate.format('YYYY-MM-DD') : ''}
              onChange={(e) => setcurrentDate(moment(e.target.value, 'YYYY-MM-DD'))}/>
          </div>
          <div className="mpField">
            <label className="modalLabel" htmlFor="mpTime">Время начала</label>
            <input
              id="mpTime"
              type="time"
              className="modalInput"
              value={matchTime}
              onChange={(e) => setMatchTime(e.target.value)}/>
            {!isValidTime(matchTime) && <span className="fieldError">Формат ЧЧ:ММ</span>}
          </div>
          <div className="mpField mpFieldWide">
            <span className="modalLabel">Стадион</span>
            <SelectSearch
              options={stadiumsData}
              search
              value={stadium}
              filterOptions={fuzzySearch}
              onChange={(x)=>setStadium(x)}
              emptyMessage="Стадион не найден"
              placeholder="Стадион"/>
          </div>
          <div className="mpField mpFieldWide">
            <span className="modalLabel">Судьи</span>
            {renderRefereeList()}
            {refereeIds().length < MAX_REFEREES && (
              <SelectSearch
                options={refereeOptionsToAdd()}
                search
                value=""
                filterOptions={fuzzySearch}
                onChange={(x)=>addReferee(x)}
                emptyMessage="Судья не найден"
                placeholder={refereeIds().length ? '+ Добавить ещё судью' : '+ Добавить судью'}/>
            )}
            <span className="fieldHint">
              Первый в списке — главный судья, остальные — помощники. Не больше {MAX_REFEREES} судей на матч.
            </span>
          </div>
        </div>
        <div className="mpModalActions">
          <button type="button" className="lgGhostBtn" disabled={infoSaving} onClick={() => setInfoModal(false)}>Отмена</button>
          <button type="button" className="lgPrimaryBtn" onClick={saveMatchInfo} disabled={infoSaving}>
            {infoSaving ? 'Сохраняем…' : 'Сохранить данные матча'}
          </button>
        </div>
      </div>
    </CustomModal>
  )

  const renderStateModal = () => (
    <CustomModal
      styles={{width:640, height:'auto', paddingLeft:36, paddingRight:36}}
      visible={stateModal}
      closeModal={() => { if (!stateSaving) setStateModal(false); }}>
      <div className="mpModalBody">
        <div className="customModalHeaderTwo">Состояние и комментарий</div>
        <div className="segmented">
          {STATE_MODES.map(mode => (
            <button
              key={mode.value}
              type="button"
              className={`segmentedItem ${stateMode === mode.value ? 'segmentedItemActive' : ''}`}
              onClick={() => setStateMode(mode.value)}>
              <strong>{mode.title}</strong>
              <span>{mode.hint}</span>
            </button>
          ))}
        </div>
        {stateMode === 'tech' && (
          <div className="mpTechScore">
            <span>{matchData.home_team_name}</span>
            <input className="modalInput" onChange={(event)=>changeScoreLoseScore(event, 'home')} type="text" aria-label="Счёт хозяев" value={matchTechLoseScore.home}/>
            <span>:</span>
            <input className="modalInput" onChange={(event)=>changeScoreLoseScore(event, 'guest')} type="text" aria-label="Счёт гостей" value={matchTechLoseScore.guest}/>
            <span>{matchData.guest_team_name}</span>
          </div>
        )}
        <div className="mpField" style={{ marginTop: 18 }}>
          <label className="modalLabel" htmlFor="mpComment">Комментарий</label>
          <textarea
            id="mpComment"
            className="modalInput mpTextarea"
            value={matchComment}
            placeholder={stateMode === 'resheduled'
              ? 'Причина или новая дата переноса'
              : stateMode === 'tech' ? 'Причина технического поражения' : 'Комментарий к матчу'}
            onChange={e => setMatchComment(e.target.value)}/>
          <span className="fieldHint">Болельщики увидят комментарий в приложении вместо состояния матча.</span>
        </div>
        <div className="mpModalActions">
          <button type="button" className="lgGhostBtn" disabled={stateSaving} onClick={() => setStateModal(false)}>Отмена</button>
          <button type="button" className="lgPrimaryBtn" onClick={saveState} disabled={stateSaving}>
            {stateSaving ? 'Сохраняем…' : 'Сохранить'}
          </button>
        </div>
      </div>
    </CustomModal>
  )

  // Короткая сводка данных матча под шапкой: видно без открытия модалки
  const renderMatchSummary = () => {
    if (!matchData) return null;
    const stadiumItem = stadiumsData.find(item => String(item.value) === String(matchData.stadium_id));
    const refNames = savedReferees
      .map(id => refereesData.find(item => String(item.value) === String(id)))
      .filter(Boolean)
      .map(item => item.name);
    const time = matchData.time ? String(matchData.time).slice(0, 5) : '';
    return (
      <div className="mpSummary">
        <span className="mpSummaryItem">
          {matchData.date ? moment(matchData.date).format('DD.MM.YYYY') : 'Дата не указана'}{time ? `, ${time}` : ''}
        </span>
        <span className={`mpSummaryItem ${stadiumItem ? '' : 'mpSummaryMissing'}`}>
          {stadiumItem ? stadiumItem.name : 'Стадион не указан'}
        </span>
        <span className={`mpSummaryItem ${refNames.length ? '' : 'mpSummaryMissing'}`}>
          {refNames.length ? `Судьи: ${refNames.join(', ')}` : 'Судья не указан'}
        </span>
        {matchData.default_comment ? <span className="mpSummaryItem">Комментарий: {matchData.default_comment}</span> : null}
      </div>
    );
  }

  const renderContent = () => {
    if(!loading && matchData && !_.isEmpty(matchData)){
      return (
          <div style={{width:'100%'}}>
            
            <div className="matchChangeResultsButtonContainerWrapper">
            <div className="matchChangeResultsButtonContainer">
              <div onClick={()=>setEventsModalVisible(true)} className={manualEvents.length > 0 ? "matchChangeDataResultsButtonGreen" : "matchChangeDataResultsButton"} style={{width:200}}>
                <span className="matchChangeResultsButtonText">
                  {manualEvents.length > 0 ? `Минуты событий (${manualEvents.length})` : 'Указать минуты событий'}
                </span>
              </div>
              <div onClick={()=>setOnlineMatchVisible(true)} className="matchChangeDataResultsButton" style={{width:150, backgroundColor:'#6c3483'}}>
                <span className="matchChangeResultsButtonText">Онлайн матч</span>
              </div>
              <label className="mpCheck">
                <input
                  type="checkbox"
                  checked={timelineDis}
                  onChange={(e)=>setTimelineDis(e.target.checked)}/>
                Показывать время событий
              </label>
            </div>
            </div>
            <div className="matchHeading">
              <span className="matchHeadingText">{matchData.league_name}. {matchData.stage_name}</span>
            </div>
            <div className="matchHeading">
              <span className="matchHeadingText">{moment(matchData.date).format("DD/MM/YYYY")} {matchData.time ?matchData.time.substring(matchData.time.length - 3 ,0) : '—'}</span>
            </div>
            <div className="matchTeamsWrapper">
              <div className="matchTeamWrapper">
                <span className="matchTeamText">{matchData.home_team_name}</span>
                {rendeTeamImage(matchData.home_team_image)}   
              </div>
              <div className="matchTeamWrapper matchTeamGuestWrapper">
                {rendeTeamImage(matchData.guest_team_image)}   
                <span className="matchTeamText">{matchData.guest_team_name}</span>
              </div>
              <div className="matchResultWrapper">
                <div className="matchResultInputs">
                  <input className="matchResultInput" onChange={(event)=>changeScore(event, 'home')} type="text" name="Счет" value={matchScore.home ?matchScore.home :''}/>
                  <span className="matchResultDivider">—</span>
                  <input className="matchResultInput" onChange={(event)=>changeScore(event, 'guest')} type="text" name="Счет" value={matchScore.guest ?matchScore.guest :''}/>
                </div>
              </div>
            </div>
            <div className="matchSubsTablesWrapper">
              <div className="tableWrapper matchSubsTable">
                <div className="table-responsive matchSubsTableOne">
                  <table className="table matchSubsOneTable">
                    <thead>
                      <tr>
                        <th className="matchSubsColumn">№</th>
                        <th className="matchSubsPlayer">Игрок</th>
                        <th className="matchSubsColumn">П*</th>
                        <th className="matchSubsColumn">Гол</th>
                        <th className="matchSubsColumn">Пас</th>
                        <th className="matchSubsColumn">АГ</th>
                        <th className="matchSubsColumn">ЖК</th>
                        <th className="matchSubsColumn">КК</th>
                      </tr>
                    </thead>
                    <tbody>
                      {renderSubs(matchData.home_team_id)}
                      <tr className="matchCenterRow">
                        <td className="matchSubsColumn"></td>
                        <td className="matchSubsPlayer">Всего</td>
                        <td onClick={()=>chooseAll(matchData.home_team_id)} className="matchSubsColumn">
                          <span >{getAllAmount(false,matchData.home_team_id)}</span>
                        </td>
                        <td className="matchSubsColumn">
                          <span>{getAllAmount('goals', matchData.home_team_id)}</span>
                        </td>
                        <td className="matchSubsColumn">
                          <span>{getAllAmount('assists', matchData.home_team_id)}</span>
                        </td>
                        <td className="matchSubsColumn">
                          <span>{getAllAmount('autogoals', matchData.home_team_id)}</span>
                        </td>
                        <td className="matchSubsColumn">
                          <span>{getAllAmount('yellow_cards', matchData.home_team_id)}</span>
                        </td>
                        <td className="matchSubsColumn">
                          <span>{getAllAmount('red_cards', matchData.home_team_id)}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="tableWrapper matchSubsTable">
                <div className="table-responsive matchSubsTableOne">
                <table className="table matchSubsOneTable">
                    <thead>
                      <tr>
                        <th className="matchSubsColumn">№</th>
                        <th className="matchSubsPlayer">Игрок</th>
                        <th className="matchSubsColumn">П*</th>
                        <th className="matchSubsColumn">Гол</th>
                        <th className="matchSubsColumn">Пас</th>
                        <th className="matchSubsColumn">АГ</th>
                        <th className="matchSubsColumn">ЖК</th>
                        <th className="matchSubsColumn">КК</th>
                      </tr>
                    </thead>
                    <tbody>
                    {renderSubs(matchData.guest_team_id)}
                    <tr className="matchCenterRow">
                        <td className="matchSubsColumn"></td>
                        <td className="matchSubsPlayer">Всего</td>
                        <td className="matchSubsColumn">
                          <div onClick={()=>chooseAll(matchData.guest_team_id)}>
                            <span>{getAllAmount(false,matchData.guest_team_id)}</span>
                          </div>
                        </td>
                        <td className="matchSubsColumn">
                          <span>{getAllAmount('goals', matchData.guest_team_id)}</span>
                        </td>
                        <td className="matchSubsColumn">
                          <span>{getAllAmount('assists', matchData.guest_team_id)}</span>
                        </td>
                        <td className="matchSubsColumn">
                          <span>{getAllAmount('autogoals', matchData.guest_team_id)}</span>
                        </td>
                        <td className="matchSubsColumn">
                          <span>{getAllAmount('yellow_cards', matchData.guest_team_id)}</span>
                        </td>
                        <td className="matchSubsColumn">
                          <span>{getAllAmount('red_cards', matchData.guest_team_id)}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="mpFinishBar">
              <span className="fieldHint">
                Сохраняет счёт, составы и события и делает матч завершённым.
                Дата, время, стадион и судьи из блока 1 сохранятся вместе с результатом.
              </span>
              <button type="button" className="lgPrimaryBtn" onClick={finishMatch} disabled={loadingFetchApplication}>
                {loadingFetchApplication ? 'Сохраняем…' : 'Завершить матч и сохранить результат'}
              </button>
            </div>
          </div>
      )
    } else {

      return (
        <div className="loadingOverlay">
          <div className="loadingWrapper">
            <Loader
              type="Rings"
              color="#04a9f5"
              height={40}
              width={40}
              timeout={0}/>
            <span style={{marginLeft:10}}>Загрузка матча</span>
          </div>
        </div>
      )
    }
  }


  const matchStatus = matchStatusOf(matchData);

  return (
    <div className="layoutWrapper">
        <div className="matchCenterWrapper">
          <div className="matchResultsHeader mpHeader">
            <div className="mpHeaderMain">
              <span className="matchResultsName">
                {matchData ? `${matchData.home_team_name} — ${matchData.guest_team_name}` : 'Матч'}
              </span>
              {matchStatus && <span className={`mpBadge ${matchStatus.className}`}>{matchStatus.label}</span>}
            </div>
            <div className="mpHeaderActions">
              <button type="button" className="lgGhostBtn" onClick={openInfoModal} disabled={!matchData}>
                Данные матча
              </button>
              <button type="button" className="lgGhostBtn" onClick={openStateModal} disabled={!matchData}>
                Состояние и комментарий
              </button>
              <button type="button" className="lgGhostBtn" onClick={() => props.history.push(`/manage_match_media/${props.match.params.id}`)}>
                Медиа матча
              </button>
              <button type="button" className="lgGhostBtn mpDangerBtn" onClick={() => setResetModal(true)} disabled={!matchData}>
                Сбросить матч
              </button>
            </div>
          </div>
          {renderMatchSummary()}
          {renderWarning()}
          {renderContent()}
          <div className="matchResultsHintWrapper">
            <span className="matchResultsHint">П - Присутствие на матче</span>
          </div>
        </div>
        <div ref={modalRef} className="matchResultsModalWrapper">
          <BottomModal text={modalText} type={modalType}/>
        </div>
        {matchData ? renderMatchInfoModal() : null}
        {matchData ? renderStateModal() : null}

        <CustomModal
          styles={{width:520, height:'auto', paddingLeft:40, paddingRight:40}}
          visible={resetModal}
          closeModal={() => { if (!resetting) setResetModal(false); }}>
          <div>
            <div className="customModalHeaderTwo">
              Сбросить матч
            </div>
            <div className="mpResetOptions">
              <button type="button" className="mpResetOption" disabled={resetting} onClick={() => resetMatch('state')}>
                <strong>Сбросить состояние</strong>
                <span>Матч снова «не начат». Заявка на матч, события и счёт остаются.</span>
              </button>
              <button type="button" className="mpResetOption mpResetDanger" disabled={resetting} onClick={() => resetMatch('full')}>
                <strong>Сбросить полностью</strong>
                <span>Удаляются заявка игроков на матч, события и счёт, матч снова «не начат».</span>
              </button>
            </div>
            <div className="mpActions" style={{ marginTop: 0 }}>
              <button type="button" className="lgGhostBtn" disabled={resetting} onClick={() => setResetModal(false)}>
                {resetting ? 'Сбрасываем…' : 'Отмена'}
              </button>
            </div>
          </div>
        </CustomModal>

        <CustomModal
          styles={{width:720, height:'auto', maxHeight:'85vh', paddingLeft:30, paddingRight:30, overflow:'auto'}}
          visible={eventsModalVisible}
          closeModal={()=>setEventsModalVisible(false)}>
          <div className="eventsModalContainer">
            <div className="customModalHeaderTwo">
              Указать минуты событий
            </div>

            {/* Event type summary — only for counted events */}
            <div className="eventsModalSummary">
              {Object.entries(EVENT_TYPES).map(([typeId, typeInfo]) => {
                if (!typeInfo.counted) return null;
                const needed = getTotalNeededForType(typeId);
                const assigned = getTotalAssignedForType(typeId);
                if (needed === 0) return null;
                return (
                  <span key={typeId} className={`eventsModalSummaryItem ${assigned >= needed ? 'eventsModalSummaryDone' : ''}`}>
                    {typeInfo.icon} {typeInfo.label}: {assigned}/{needed}
                  </span>
                );
              })}
              {/* Free events counts */}
              {Object.entries(EVENT_TYPES).map(([typeId, typeInfo]) => {
                if (typeInfo.counted) return null;
                const count = getTotalAssignedForType(typeId);
                if (count === 0) return null;
                return (
                  <span key={typeId} className="eventsModalSummaryItem eventsModalSummaryFree">
                    {typeInfo.icon} {typeInfo.label}: {count}
                  </span>
                );
              })}
            </div>

            {/* Add event form */}
            <div className="eventsModalForm">
              <div className="eventsModalFormRow">
                <div className="eventsModalFormField">
                  <label className="eventsModalLabel">Тип события</label>
                  <select 
                    className="eventsModalSelect" 
                    value={currentEventType} 
                    onChange={(e) => { setCurrentEventType(e.target.value); setCurrentEventPlayer(''); setCurrentEventAssist(''); }}>
                    {Object.entries(EVENT_TYPES).map(([typeId, typeInfo]) => (
                      <option key={typeId} value={typeId}>{typeInfo.icon} {typeInfo.label}</option>
                    ))}
                  </select>
                </div>

                <div className="eventsModalFormField">
                  <label className="eventsModalLabel">Игрок</label>
                  <select 
                    className="eventsModalSelect" 
                    value={currentEventPlayer} 
                    onChange={(e) => { setCurrentEventPlayer(e.target.value); setCurrentEventAssist(''); }}>
                    <option value="">-- Выберите --</option>
                    {getPlayersForEventType(currentEventType).map(p => (
                      <option key={p.id} value={p.id}>
                        {p.player_number ? `#${p.player_number} ` : ''}{p.family} {p.name} ({matchData.home_team_id === p.team_id ? matchData.home_team_name : matchData.guest_team_name})
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              {EVENT_TYPES[parseInt(currentEventType)] && EVENT_TYPES[parseInt(currentEventType)].hasAssist && currentEventPlayer && (
                <div className="eventsModalFormRow">
                  <div className="eventsModalFormField" style={{flex: 1}}>
                    <label className="eventsModalLabel">Ассистент (необязательно)</label>
                    <select 
                      className="eventsModalSelect" 
                      value={currentEventAssist} 
                      onChange={(e) => setCurrentEventAssist(e.target.value)}>
                      <option value="">-- Без ассистента --</option>
                      {getAssistPlayersForGoal(parseInt(currentEventPlayer)).map(p => (
                        <option key={p.id} value={p.id}>
                          {p.player_number ? `#${p.player_number} ` : ''}{p.family} {p.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              )}

              <div className="eventsModalFormRow">
                <div className="eventsModalFormField eventsModalTimeField">
                  <label className="eventsModalLabel">Минута</label>
                  <input 
                    className="eventsModalTimeInput"
                    type="text" 
                    maxLength="3"
                    placeholder="0"
                    value={currentEventMinute}
                    onChange={(e) => setCurrentEventMinute(e.target.value.replace(/[^0-9]/g, ''))}
                  />
                </div>
                <span className="eventsModalTimeSeparator">:</span>
                <div className="eventsModalFormField eventsModalTimeField">
                  <label className="eventsModalLabel">Секунда</label>
                  <input 
                    className="eventsModalTimeInput"
                    type="text" 
                    maxLength="2"
                    placeholder="00"
                    value={currentEventSecond}
                    onChange={(e) => {
                      const val = e.target.value.replace(/[^0-9]/g, '');
                      if (parseInt(val) < 60 || val === '') setCurrentEventSecond(val);
                    }}
                  />
                </div>
                <div className="eventsModalFormField" style={{flex: 0}}>
                  <label className="eventsModalLabel">&nbsp;</label>
                  <div 
                    onClick={addManualEvent}
                    className={currentEventPlayer && currentEventMinute !== '' ? "eventsModalAddButton" : "eventsModalAddButtonDisabled"}>
                    <span className="matchChangeResultsButtonText">Добавить</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Events list */}
            {manualEvents.length > 0 && (
              <div className="eventsModalList">
                <div className="eventsModalListHeader">
                  <span className="eventsModalListTitle">Добавленные события ({manualEvents.length})</span>
                </div>
                <table className="eventsModalTable">
                  <thead>
                    <tr>
                      <th>Мин.</th>
                      <th>Тип</th>
                      <th>Игрок</th>
                      <th>Команда</th>
                      <th>Ассистент</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {[...manualEvents].sort((a, b) => a.minute - b.minute || a.second - b.second).map(ev => (
                      <tr key={ev.id}>
                        <td className="eventsModalTableTime">{ev.minute}'{ev.second > 0 ? ev.second.toString().padStart(2, '0') + '"' : ''}</td>
                        <td>{EVENT_TYPES[ev.event_type] ? EVENT_TYPES[ev.event_type].icon + ' ' + EVENT_TYPES[ev.event_type].label : ev.event_type}</td>
                        <td>{ev.player_number ? `#${ev.player_number} ` : ''}{ev.player_name}</td>
                        <td>{ev.team_name}</td>
                        <td>{ev.assist_player_name || '—'}</td>
                        <td>
                          <span className="eventsModalRemoveBtn" onClick={() => removeManualEvent(ev.id)}>✕</span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}

            {/* Status message */}
            {manualEvents.length > 0 && (
              <div className={`eventsModalStatus ${allEventsAssigned() ? 'eventsModalStatusDone' : 'eventsModalStatusWarning'}`}>
                {allEventsAssigned() 
                  ? '✓ Все события указаны. При сохранении будут использованы указанные минуты.'
                  : '⚠ Не все события указаны. Необходимо добавить минуты для всех голов, автоголов, ЖК и КК, указанных в таблице.'}
              </div>
            )}

            <div className="manageApplicationButtonsModalWrapper" style={{marginTop: 15, marginBottom: 15}}>
              <div onClick={()=>setEventsModalVisible(false)} className="matchChangeResultsButton">
                <span className="matchChangeResultsButtonText">Готово</span>
              </div>
              {manualEvents.length > 0 && (
                <div onClick={()=>{ setManualEvents([]); }} style={{backgroundColor:'rgb(253,54,71,1)'}} className="matchChangeResultsButton">
                  <span className="matchChangeResultsButtonText">Очистить все</span>
                </div>
              )}
            </div>
          </div>
        </CustomModal>

        {/* Online Match Modal */}
        <OnlineMatch
          visible={onlineMatchVisible}
          closeModal={() => setOnlineMatchVisible(false)}
          matchData={matchData}
          matchApplication={matchApplication}
          onMatchFinish={handleOnlineMatchFinish}
        />
    </div>
  );
}